<template>
  <jc-dialog ref="dialog" :show.sync="show"
             btn-confirm-text='<i class="far fa-trash-alt"></i> Xóa'
             title="Xác nhận xóa"
             type="red"
             @onConfirm="onDelete()"
  >
    <table class="table table-hover">
      <tr>
        <th>#</th>
        <td>{{ model.index }}</td>
      </tr>
      <tr>
        <th>Key</th>
        <td>{{ model.key }}</td>
      </tr>
      <tr>
        <th>Value</th>
        <td>{{ model.value }}</td>
      </tr>
      <tr>
        <th>Type</th>
        <td>{{ model.type }}</td>
      </tr>
      <tr>
        <th>Status</th>
        <td>{{ model.status === 1 ? true : false }}</td>
      </tr>
      <tr>
        <th>Description</th>
        <td>{{ model.description }}</td>
      </tr>
    </table>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "Delete",
  mixins: [
    dialogMixins,
  ],
  data() {
    return {
      model: {},
      show: false
    }
  },
  methods: {
    open(item) {
      if (item) {
        this.show = true;
        this.model = item;
      } else {
        this.$warning('Chưa chọn bản ghi nào')
      }
    },
    onDelete() {
      this.$showLoader();
      const vue = this;
      let data = vue.model;
      vue.$adminService
      .delete(`/v1.0/config/system-config?config_type=${data.type}&config_key=${data.key}`)
      .then(successRes => {
        this.close();
        this.$success();
        this.$stopLoader();

        this.$emit("success", successRes);
      }, errorRes => {
        this.$stopLoader();
        this.errorNotify(errorRes)
        .then(errorRes => this.$cmsBadRequest(errorRes));
        this.$emit("error", errorRes);
      });
    }
  }
}
</script>

<style scoped>

</style>